var map = {
	"./ana.mp3": 1371,
	"./ashe.mp3": 5234,
	"./baptiste.mp3": 6621,
	"./bastion.mp3": 1081,
	"./brigitte.mp3": 545,
	"./cassidy.mp3": 9415,
	"./d.va.mp3": 2218,
	"./doomfist.mp3": 3310,
	"./echo.mp3": 2284,
	"./genji.mp3": 3396,
	"./hanzo.mp3": 2209,
	"./illari.mp3": 4070,
	"./junker-queen.mp3": 1581,
	"./junkrat.mp3": 9546,
	"./juno.mp3": 8521,
	"./kiriko.mp3": 8222,
	"./lifeweaver.mp3": 9845,
	"./lucio.mp3": 4045,
	"./mauga.mp3": 438,
	"./mei.mp3": 5942,
	"./mercy.mp3": 9209,
	"./moira.mp3": 6239,
	"./orisa.mp3": 6097,
	"./pharah.mp3": 701,
	"./ramattra.mp3": 1721,
	"./reaper.mp3": 8694,
	"./reinhardt.mp3": 9894,
	"./roadhog.mp3": 2926,
	"./sigma.mp3": 6596,
	"./sojourn.mp3": 2877,
	"./soldier--76.mp3": 5958,
	"./sombra.mp3": 2375,
	"./symmetra.mp3": 9725,
	"./torbjörn.mp3": 1440,
	"./tracer.mp3": 8604,
	"./venture.mp3": 5716,
	"./widowmaker.mp3": 221,
	"./winston.mp3": 1697,
	"./wrecking-ball.mp3": 4745,
	"./zarya.mp3": 4072,
	"./zenyatta.mp3": 3021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1661;